import { generateClient } from "aws-amplify/api";
import { getCurrentUser } from "@/graphql/queries";
const client = generateClient();
export const GetCurrentUserInfo = {
  methods: {
    async GetCurrentUserInfoMethod(user_email_id) {
      try {
        let result = await client.graphql({
          query: getCurrentUser,
          variables: {
            input: {
              user_email_id,
            },
          },
        });
        var ResultObj = JSON.parse(result.data.getCurrentUser);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.$store.commit(
            "SET_CURRENTUSER_DETAILS",
            ResultObj.data.items?.[0],
          );
          return ResultObj.data.items?.[0] || {};
        }
      } catch (error) {
        this.noDataText = error.errors[0].message;
        console.log("Error", error);
      }
    },
  },
};
